import { useOne, useParse } from "@refinedev/core";
import { CreateEventStep, EventType } from "interfaces";
import { FullScreenLoading } from "components/fullScreenLoading";
import { HistoryLogButton } from "components/historyLogButton";
import Button from "components/button";
import {
  StepsMenu,
  ViewAdditionalSetup,
  ViewBuildEventPageStep,
  ViewParticipantTemplatesStep,
  ViewTicketSetup,
} from "components/shared/event";
import { Link } from "react-router-dom";
import { isHaveActionPermission } from "utills/helpers";

export const SportEventDetail: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const { data, isLoading } = useOne<any>({
    resource: "content/events",
    id: `${params?.id}${
      Number(params?.step) === CreateEventStep.BUILD_EVENT_PAGE
        ? ""
        : "?simple=true"
    }`,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!(params?.step && params?.id),
    } as any,
  });

  const eventDetailData = data?.data;

  const renderStep = (eventDetailData: any) => {
    const step = Number(params?.step ?? 1);
    if (step <= eventDetailData.current_step + 1) {
      switch (step) {
        case CreateEventStep.BUILD_EVENT_PAGE:
          return <ViewBuildEventPageStep eventDetailData={eventDetailData} />;
        case CreateEventStep.PARTICIPANT_TEMPLATE:
          return (
            <ViewParticipantTemplatesStep eventDetailData={eventDetailData} />
          );
        case CreateEventStep.CREATE_TICKET_PHASE:
          return <ViewTicketSetup eventDetailData={eventDetailData} />;
        case CreateEventStep.ADDITIONAL_SETUP:
          return <ViewAdditionalSetup eventDetailData={eventDetailData} />;
        case CreateEventStep.PUBLISH:
          return <></>;
        default:
          return <></>;
      }
    }
    return <></>;
  };

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="shrink-0">
        <StepsMenu
          currentStep={eventDetailData?.current_step ?? 1}
          eventType={EventType.SPORT}
          isEdit={false}
        />
      </div>
      <div className="flex-1">
        {eventDetailData ? (
          <div>
            <div className="flex justify-between items-center gap-x-2 mb-4">
              <p className="font-medium">
                {eventDetailData?.name?.en ??
                  eventDetailData?.name[
                    Object.keys(eventDetailData.name)[0] ?? "en"
                  ] ??
                  ""}{" "}
              </p>
              <div className="flex items-center gap-x-3">
                {Number(params?.step) !==
                CreateEventStep.PARTICIPANT_TEMPLATE ? (
                  <HistoryLogButton
                    id="event-step"
                    resource={`content/events/${eventDetailData?.id}/steps/${params?.step}/history`}
                    className="py-1.5"
                  />
                ) : (
                  <></>
                )}
                {isHaveActionPermission("sports", "events", "edit") ? (
                  <Link
                    to={`/events/sports/${params?.id}/edit?step=${Number(
                      params?.step
                    )}`}
                  >
                    <Button className="text-sm w-20 border-solid border-brand-500 border-2 py-2">
                      Edit
                    </Button>
                  </Link>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {renderStep(eventDetailData)}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
